import { render } from "./SideBarCard.vue?vue&type=template&id=4cadd9bb&scoped=true"
import script from "./SideBarCard.vue?vue&type=script&lang=js"
export * from "./SideBarCard.vue?vue&type=script&lang=js"

import "./SideBarCard.vue?vue&type=style&index=0&id=4cadd9bb&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cadd9bb"]])

export default __exports__